import BaseService from '_services/rest/base';
import axios from 'axios';
import Events from '_utils/events';
import { _SALVE_CUSTOMER_SUCCESS_ } from '_modules/customer/components/CustomerModel';
import axiosHeader from '_common/runs/axios';

class CustomerService extends BaseService {
  constructor() {
    super();
  }

  deleteCustomer(id) {
    return this.request(`${this.getUrl()}/${id}`, null, 'DELETE')
      .catch(err => {
        throw err;
      });
  }

  getUrl() {
    return `${super.getUrl()}api/customer`;
  }

  getCep(cep) {
    axios.defaults.headers.common = {};
    return axios.get(`https://viacep.com.br/ws/${cep}/json`, null)
      .then(response => {
        axiosHeader();
        return response.data;
      })
      .catch(err => {
        throw err;
      });
  }

  getUrlAddress(id, addressId = null) {
    if (addressId) {
      return {
        url: `${this.getUrl()}/${id}/address/${addressId}`,
        method: 'PUT',
      };
    }
    return {
      url: `${this.getUrl()}/${id}/address`,
      method: 'POST',
    };
  }

  getUrlContact(id, contactId) {
    if (contactId) {
      return {
        url: `${this.getUrl()}/${id}/contact/${contactId}`,
        method: 'PUT',
      };
    }
    return {
      url: `${this.getUrl()}/${id}/contact`,
      method: 'POST',
    };
  }

  getUrlSave(id) {
    if (id) {
      return {
        url: `${this.getUrl()}/${id}`,
        method: 'PUT',
      };
    }
    return {
      url: `${this.getUrl()}`,
      method: 'POST',
    };
  }

  getCustomerById(id) {
    return this.request(`${this.getUrl()}/${id}`)
      .then(response => response.data)
      .catch(err => {
        throw err;
      });
  }

  getList(params) {
    const filters = { search: params.search };

    return this.request(`${this.getUrl()}/all/${params.skip}/${params.take}`, filters)
      .then(response => response.data)
      .catch(err => {
        throw err;
      });
  }

  prepareRequestSaveAddress(customerId, addresses) {
    addresses.map(address => this.saveAddress(customerId, address));
  }

  removeAddress(id, addressId) {
    return this.request(`${this.getUrl()}/${id}/address/${addressId}`, null, 'DELETE')
      .then(response => response.data)
      .catch(err => {
        throw err;
      });
  }

  save(customer) {
    const meta = this.getUrlSave(customer.id);
    return this.request(meta.url, customer, meta.method)
      .then(response => {
        Events.$emit(_SALVE_CUSTOMER_SUCCESS_, response.data);
        return response.data;
      })
      .catch(err => {
        throw err;
      });
  }

  saveAddress(id, address) {
    const meta = this.getUrlAddress(id, address.id);
    return this.request(meta.url, address, meta.method)
      .then(response => response.data)
      .catch(err => {
        throw err;
      });
  }

  saveContact(id, contact) {
    const meta = this.getUrlContact(id, contact.id);
    return this.request(meta.url, contact, meta.method)
      .then(response => response.data)
      .catch(err => {
        throw err;
      });
  }
}

export default new CustomerService();
